import 'widget/components/VehicleExtraCta/VehicleExtraCta.scss';

import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';

import { ContentZonesService } from '@sm360/widget-commons-core-services';
import { MEDIA_QUERIES } from '@sm360/widget-commons-general';
import { Vehicle } from '@sm360/widget-commons-vehicle';
import VehicleExtraCtaItem from 'vdp-used/components/VehicleExtraCta/VehicleExtraCtaItem/VehicleExtraCtaItem.jsx';

const CZGROUP = 'widget.vdp.used.actions.cta';

function VehicleExtraCtaItemFactory(czLocation, czDefault, onClick) {
    const image = ContentZonesService.getContentZone(CZGROUP, `${czLocation}.img`)
        ? ContentZonesService.getContentZone(CZGROUP, `${czLocation}.img`).getValue()
        : '';

    const tagline = ContentZonesService.getContentZone(CZGROUP, `${czLocation}.text`)
        ? ContentZonesService.getContentZone(CZGROUP, `${czLocation}.text`).getValue()
        : czDefault.tagline;

    const button = ContentZonesService.getContentZone(CZGROUP, `${czLocation}.button`)
        ? ContentZonesService.getContentZone(CZGROUP, `${czLocation}.button`).getValue()
        : czDefault.button;

    return (
        <VehicleExtraCtaItem
            key={czLocation}
            image={image}
            tagline={tagline}
            button={button}
            onClick={onClick}
            location={czLocation}
        />
    );
}

const VehicleExtraCtaItemList = ({ ctaData }) => {
    const CallToActionsGroup = Object.keys(ctaData).map((key) => {
        return VehicleExtraCtaItemFactory(ctaData[key].location, ctaData[key].default, ctaData[key].onClick);
    });

    return (
        <div className="vehicle-extra-cta--container">
            <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX - 1}>
                <div className="vehicle-extra-cta--content is-mobile">{CallToActionsGroup}</div>
            </MediaQuery>
            <MediaQuery minWidth={MEDIA_QUERIES.MOBILE.MAX + 1}>
                <div className="vehicle-extra-cta--content">{CallToActionsGroup}</div>
            </MediaQuery>
        </div>
    );
};

VehicleExtraCtaItemList.propTypes = {
    ctaData: PropTypes.instanceOf(Vehicle.VehicleModel).isRequired,
};

VehicleExtraCtaItemList.displayname = 'VehicleExtraCtaItemList';

export default VehicleExtraCtaItemList;
